import React from 'react';
import { useTranslation } from 'react-i18next';

export const Error500Box = () => {
  const { t } = useTranslation();
  return (
    <div className="ct-permission-error" data-e2e="ct-error-500-page">
      <h1>{t('server_error')}</h1>
      <p>{t('error_500_message')}</p>
      <a href="/">{t('try_again')}</a>
      <span>{t('error_500')}</span>
    </div>
  );
};
